<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HzI5RV/tc-custom/9781480473843.jpg?1733034791351" alt="This image is the cover for the book Halfway Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Halfway Home
      </h1>
      <p class="bookDescription body article font2">
        <b>Tom tried everything to get away from the world—but it had a way of getting back to him</b><br/><br/>When Tom was diagnosed with AIDS, he thought of it as a death sentence. His life was effectively over. He packed up everything and moved to a beach house in California. There, he could live out what remained of his life in peace. His landlord was kind, understanding—and interested in him romantically. Tom had found the safe haven he sought. That is, until his brother, Brian, reappeared in his life.<br/><br/>Brian’s shady business connections back home have him and his family on the run. With him are his homophobic wife, Susan, and his son, Daniel, who has never met his uncle. Thrown into an explosive situation, Tom and his family struggle to become closer. But when Brian’s dirty dealings follow him to California and threaten the lives of the entire family, the bond between the two brothers is put to the test.<br/><br/>Paul Monette displays a keen awareness of family dynamics as he explores coming out, life-threatening illness, and the lifelong consequences of brotherly conflicts. <i>Halfway Home </i>is a novel about anger and reconciliation, love and danger.<br/><br/>This ebook features an illustrated biography of Paul Monette including rare images and never-before-seen documents from the Paul Monette papers of the UCLA Library Special Collections.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Monette
      </h2>
      
      <p class="authorDescription body article">Paul Monette (1945&ndash;1995) was an author, poet, and gay rights activist. Born in Massachusetts and educated at Yale University, he moved with his partner Roger Horwitz to Los Angeles in 1978 and became involved in the gay rights movement. Monette&rsquo;s writing captures the sense of heartbreak and loss at the center of the AIDS crisis. His first novel, <I>Taking Care of Mrs. Carroll</I>, was published in 1978, and he went on to write several more works of fiction, poetry, and memoir. <I>Borrowed Time: An AIDS Memoir</I>, the tender account of his partner&rsquo;s battle with the disease, earned him both PEN Center West and Lambda literary awards. In 1992, Monette won the National Book Award in Nonfiction for <I>Becoming a Man: Half a Life Story</I>, an autobiography detailing his early life and his struggle with his sexuality. Written as a classic coming-of-age story, <I>Becoming a Man</I> became a seminal coming-out story. In 1995, Monette founded the Monette-Horwitz Trust, which honors individuals and organizations working to combat homophobia. Monette died in his home in West Hollywood in 1995 of complications from AIDS.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5fefae10